import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationToolUploadField from '../../../types/upload-field'
import CreationToolUserRestriction from '../../../types/user-restriction'
import TagsField from '../../form-fields/upload/tags'
import { CreationToolUploadContext } from '../manager'
import { CreationToolUploadTag } from '../types'
import { CopilotContext } from '../copilot/context'
import TagManager from './tag-manager'

const Tags = styled(TagsField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadTagsField = ({ className, field, sourceId }: Props) => {
    const { getActivePreset } = useContext(CopilotContext)
    const preset = getActivePreset()

    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const { uploadSources, tags, addTags, removeTags, toggleFeaturedTags, enableFeaturedTags } =
        useContext(CreationToolUploadContext)
    const [displayTags, setDisplayTags] = useState<CreationToolUploadTag[]>([])

    const canViewSuggestedTags = CreationToolUserRestriction.hasAccess(
        CreationToolUserRestriction.CanViewSuggestedTags,
        userRestrictionAccess
    )

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find((src) => src.id === sourceId)
            if (source) {
                setDisplayTags(source.tags)
            }
        } else {
            setDisplayTags(tags)
        }
    }, [tags, sourceId, uploadSources])

    return (
        <Tags
            {...{
                className,
                field,
                isBulk: uploadSources.length > 1 && !sourceId,
                showInstructions: !sourceId,
                tags: displayTags,
                onAdd: (tags) =>
                    addTags(
                        tags.map((text) => ({ text })),
                        sourceId
                    ),
                onRemove: (tag) => removeTags([tag], sourceId),
                onToggleFeatured: (tag) => toggleFeaturedTags([tag], sourceId),
                enableFeatured: enableFeaturedTags,
            }}
        >
            {canViewSuggestedTags && preset && (
                <TagManager sourceId={sourceId} pills={displayTags} field={CreationToolUploadField.TagManager} />
            )}
        </Tags>
    )
}

export default CreationUploadTagsField
